import React, { Component } from "react";
import { withNamespaces } from "react-i18next";
import { AiFillPlusCircle, AiFillMinusCircle } from 'react-icons/ai';

import Skeleton from "react-loading-skeleton";
import DataTable from "../../../components/Datatable/DataTable";
import Auxiliary from "../../../hoc/Auxiliary/Auxiliary";
import StringInput from "../../../components/Input/StringInput/StringInput";
import Button from "../../../components/Button/Button";
import DateTimePicker from "../../../components/DateTimePicker/DateTimePicker";
import Select from "../../../components/Input/Select/Select";
// import moment from "moment";

class EventBetListing extends Component {
    /* ============ Component Lifecycle [START] ============ */
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {}

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }
    /* ============ Component Lifecycle [END] ============ */

    render() {
        const { t } = this.props;
        let rsListing = [];
        
        /* ======================== datatables data assign [START] ======================== */
        const columns = [
            {
                text: t("event_bet_listing.no"),
                dataField: "no",
                formatter: this.props.noFormatter,
                headerStyle: { width: "60px", textAlign: "center" },
            },
            {
                text: t("event_bet_listing.member"),
                dataField: "username",
                sort: true,
                onSort: this.props.onSort
            },
            {
                text: t("event_bet_listing.order_id"),
                dataField: "order_id",
                sort: false,
                formatter: this.props.orderIDFormatter
            },
            {
                text: t("event_bet_listing.league"),
                dataField: "league",
                sort: false,
            },
            {
                text: t("event_bet_listing.match"),
                dataField: "match",
                sort: false,
            },
            {
                text: t("event_bet_listing.bet"),
                dataField: "bet",
                sort: false,
            },
            {
                text: t("event_bet_listing.match_date"),
                dataField: "match_date",
                sort: true,
                onSort: this.props.onSort
            },
            {
                text: t("event_bet_listing.update_date"),
                dataField: "update_date",
                sort: true,
                onSort: this.props.onSort
            }
        ];
        
        if (this.props.data) {
            rsListing = this.props.data.map((val, idx) => {
                return {
                    no: idx+1,
                    username: val.username,
                    order_id: val.order_id,
                    league: t("world_cup."+val.league),
                    match: t("world_cup."+val.team_a) + " vs " + t("world_cup."+val.team_b),
                    bet: t("world_cup."+val.bet),
                    match_date: val.match_date,
                    update_date: val.update_date,
                    transaction_id: val.transaction_id
                };
            });
        }

        return (
            <Auxiliary>
                <div className="row row-sm">
                    <div className="breadcrumb-header justify-content-between">
                        <div className="my-auto">
                            <div className="d-flex">
                                <h4 className="content-title mb-0 my-auto text-muted mt-1 tx-13 ml-2 mb-0">{t("event_bet_listing.event_bet_listing")}</h4>
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-12">
                        <div className="card card-body">
                            <div className="col mt-auto">
                                {this.props.loading ? (
                                    <Skeleton count={2} />
                                ) : (
                            <div
                            className={`form-horizontal filter-function row
                            ${this.state.showCard?'open':'close'} filter-wrapper-1`}>
                                <div className="col-md-4 col-6">
                                    <div className="form-group">
                                        <label className="font-weight-bolder">
                                            {t("event_bet_listing.date")}
                                        </label>
                                        <div className="input-group-prepend">
                                            <span className="input-group-text">
                                                <i className="fas fa-calendar-check" />
                                            </span>
                                            <DateTimePicker
                                                id="date"
                                                name="date"
                                                className="form-control filter-input"
                                                range={true}
                                                timePicker={true}
                                                value={this.props.filter.date}
                                                onChange={this.props.onInputChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 col-6">
                                    <div className="form-group">
                                        <label className="font-weight-bolder">
                                            {t("event_bet_listing.member")}
                                        </label>
                                        <StringInput
                                            id="username"
                                            name="username"
                                            value={this.props.filter.username}
                                            onChange={this.props.onInputChange}
                                            className="filter-input"
                                            onSearchPress={(evt) =>
                                                evt.key === "Enter" &&
                                                this.props.refreshHandler()
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4 col-6">
                                    <div className="form-group">
                                        <label className="font-weight-bolder">
                                            {t("event_bet_listing.team")}
                                        </label>
                                        <Select
                                            id="team"
                                            name="team"
                                            className="form-control filter-input"
                                            onChange={this.props.onInputChange}
                                            options={this.props.dropdown.team}
                                            emptyValue={true}
                                            defaultValue={this.props.filter.team}                                            
                                        />
                                    </div>
                                </div>
                                <div className="col mt-auto">
                                    <div>
                                    <Button
                                        typeButton="button"
                                        classValue="btn btn-blue"
                                        idValue="filter"
                                        buttonName={t("global.filter")}
                                        clicked={() =>
                                            this.props.refreshHandler()
                                        }
                                    />
                                    &nbsp;
                                    <Button
                                        typeButton="button"
                                        classValue="btn btn-secondary"
                                        idValue="reset"
                                        buttonName={t("global.reset")}
                                        clicked={() =>
                                            this.props.clearHandler()
                                        }
                                    />
                                    </div>
                                </div>

                            </div>
                                    )}
                                </div>

                            <div className="show-btn"
                            onClick={()=>this.toggleCard()}>
                                {
                                    this.state.showCard? <AiFillMinusCircle/> : <AiFillPlusCircle/>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-header pb-0">
                                <div className="d-flex justify-content-between">
                                    <h4 className="card-title mg-b-0">
                                        {t("event_bet_listing.event_bet_listing")}
                                    </h4>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive table-hover datatable">
                                    <DataTable
                                        keyField="no"
                                        data={rsListing}
                                        columns={columns}
                                        activePage={this.props.activePage}
                                        limit={this.props.limit}
                                        totalItems={this.props.totalRecords}
                                        paginationHandler={(val) =>
                                            this.props.datatablesChangeHandler(
                                                val,
                                                "activePage"
                                            )
                                        }
                                        sizePerPageHandler={(val) =>
                                            this.props.datatablesChangeHandler(
                                                val,
                                                "limit"
                                            )
                                        }
                                        searchChangeHandler={(val) =>
                                            this.props.datatablesChangeHandler(
                                                val,
                                                "searchValue"
                                            )
                                        }
                                        searchValue={this.props.searchValue}
                                        hideSearchBar={true}
                                        classValue="dataTable table-bordered text-justify text-center"
                                        loading={this.props.loading}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Auxiliary>
        );
    }
}

export default withNamespaces("translation")(EventBetListing);
